var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data),expression:"data"}],staticClass:"slider",style:(_vm.style),attrs:{"type":"range","id":"salaire","name":"montantRange","min":_vm.min,"max":_vm.max},domProps:{"value":(_vm.data)},on:{"__r":function($event){_vm.data=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }